import clsx from "clsx";
import { Check } from "lucide-react";
import Row from "../row";
import { WizardSimpleStepWrapperProps } from "./types";

export default function WizardSimpleStepWrapper(
  props: Readonly<WizardSimpleStepWrapperProps>,
) {
  const { title, status, step } = props;

  return (
    <Row centered gap="md">
      <div
        className={clsx("w-6 h-6 rounded-full text-center", {
          "bg-primary text-white": status === "completed",
          "border-2 font-bold border-primary text-primary":
            status !== "completed",
        })}
      >
        {status !== "completed" && step}
        {status === "completed" && <Check size="16" className="mt-1" />}
      </div>
      <div className="flex-1 font-medium text-secondary">{title}</div>
      <div className="text-secondary/75">
        {status === "completed" ? "Complete" : "Pending"}
      </div>
    </Row>
  );
}
